import { useMemo } from 'react';
import { Radio, Row } from 'antd';
import PropTypes from 'prop-types';
import { FormEditSummaryItem } from './FormEditSummaryItem';

export const EditSummaryRadioField = ({ field, onFinish }) => {
  const fieldData = useMemo(() => {
    return { ...field, value: field.value?.find((item) => item.value)?.idInput };
  }, [field]);

  const onFinishEditingField = (result) => {
    if (!result?.save) {
      onFinish();
      return;
    }
    onFinish({
      save: true,
      newValue: { selectedItem: result.newValue?.value },
    });
  };

  return (
    <FormEditSummaryItem field={fieldData} onFinish={onFinishEditingField} showActionsInTitle>
      <Radio.Group style={{ width: '100%' }}>
        {field.value?.map((item) => (
          <Row key={item.idInput} justify="space-between" style={{ width: '100%' }}>
            <Radio value={item.idInput}>
              <span>{item.label}</span>
            </Radio>
          </Row>
        ))}
      </Radio.Group>
    </FormEditSummaryItem>
  );
};

EditSummaryRadioField.propTypes = {
  field: PropTypes.shape({
    value: PropTypes.array,
  }),
  onFinish: PropTypes.func,
};
